export default {"src":"/_next/static/image/public/images/ic_green_check_circle.34c7f1c56ce47af8a33103a1b4db09bb.svg","height":36,"width":36};